
import { ManagerDashboard } from "../components/Manager/ManagerDashboard";

const Manager = () => {
  return <ManagerDashboard />;
};

export default Manager;
